import {combineReducers} from "redux";
import commonReducer from "../../common/reducers/commonReducer.js";
import customerReducer from "./customerReducer.js";
import customerSubscriptionsReducer from "./customerSubscriptionsReducer.js";
import deliveryReducer from "./deliveryReducer.js";
import dominosReducer from "../../dominosweb/reducers/dominosReducer.js";
import historyReducer from "./historyReducer.js";
import hubOverviewReducer from "../../hubweb/reducers/hubReducer.js";
import multiChainSortimentReducer from "../../kjedeweb/reducers/multiChainSortimentReducer.js";
import multiEpixSortimentReducer from "../../kjedeweb/reducers/multiEpixSortimentReducer.js";
import notificationsReducer from "../../common/reducers/notificationsReducer";
import orderReducer from "./orderReducer";
import productImageReducer from "./productImageReducer.js";
import productListsReducer from "./productListsReducer.js";
import productQueryReducer from "./productQueryReducer.js";
import singleChainSortimentReducer from "../../kjedeweb/reducers/singleChainSortimentReducer.js";
import singleEpixSortimentReducer from "../../kjedeweb/reducers/singleEpixSortimentReducer.js";
import supportReducer from "./supportReducer.js";
import systemMessageReducer from "../../common/reducers/systemMessageReducer.js";
import viewReducer from "./viewReducer.js";

const rootReducer = combineReducers({
    ...commonReducer,
    customer: customerReducer,
    customerSubscriptions: customerSubscriptionsReducer,
    delivery: deliveryReducer,
    history: historyReducer,
    freshFoodHub: hubOverviewReducer,
    dominosweb: dominosReducer,
    multiChainSortiment: multiChainSortimentReducer,
    multiEpixSortiment: multiEpixSortimentReducer,
    notifications: notificationsReducer,
    order: orderReducer,
    productImage: productImageReducer, 
    productLists: productListsReducer,
    productQuery: productQueryReducer,
    singleChainSortiment: singleChainSortimentReducer,
    singleEpixSortiment: singleEpixSortimentReducer,
    support: supportReducer,
    systemMessage: systemMessageReducer,
    view: viewReducer,
});

export default rootReducer;